import { DATABASE_SCHEMA_VERSION } from '@/db/version'
import type { Settings } from '@/db/types'
import { APP_VERSION } from '@/app/version'

export function createDefaultSettings(now = new Date().toISOString()): Settings {
  return {
    key: 'app',
    appVersion: APP_VERSION,
    companyName: 'Real Máquinas',
    phone: '(63) 98107-2998',
    instagram: '@realmaquinasto',
    email: 'realmaquinasto@gmail.com',
    qrCodeTarget: '',
    photoMaxInputBytes: 10 * 1024 * 1024,
    photoMaxDimension: 1600,
    photoJpegQuality: 0.76,
    schemaVersion: DATABASE_SCHEMA_VERSION,
    updatedAt: now,
  }
}
